import { Platform } from '@angular/cdk/platform';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { Ativacao, Midia, Notas } from 'src/app/models/models';
import { Cliente } from '../../models/models';
import { FirebaseRequestsService } from '../../services/requests/firebase/firebase-requests.service';
import { UtilsService } from '../../services/utils.service';
import { AtivacoesService } from './../../services/ativacoes.service';
import { SecurityService } from './../../services/security.service';
import { NetworkStatusService } from '../../services/network-status.service';

@Component({
  selector: 'dialog-email',
  templateUrl: 'dialog-email.html',
})
export class DialogEmail {
  pedidoEmailRealizado;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { ativacao: Ativacao; midia: Midia },
    private ativacaoService: AtivacoesService,
    private fns: AngularFireFunctions,
    private dialog: MatDialog,
    public securityService: SecurityService,
    private spinner: NgxSpinnerService
  ) { }

  enviarEmail() {
    const callable = this.fns.httpsCallable('appMartechSendEmail');
    const data$ = callable({
      email: this.data.midia.email_cliente,
      chaveExterna: this.data.midia.id_automacao,
      parametros: this.data.midia.parametros,
    });
    data$.subscribe((res) => {
      console.log(res);
    });
    this.pedidoEmailRealizado = false;
    this.spinner.show();
    this.securityService
      .registrarEvento('executou-ativacao', {
        id_ativacao: this.data.ativacao.id_ativacao,
        id_cliente: this.data.ativacao.id_cliente,
        id_vendedor: this.data.ativacao.id_vendedor,
        midia: this.data.midia.tipo_midia,
      })
      .subscribe((res: any) => {
        this.ativacaoService.executarAcaoContato(
          this.data.ativacao,
          res.messageId
        );
        this.spinner.hide();
      });
  }

  close() {
    this.dialog.closeAll();
  }
}

@Component({
  selector: 'dialog-acesso-simulado',
  templateUrl: 'dialog-acesso-simulado.html',
  styleUrls: ['styles/dialog-acesso-simulado.scss'],
})
export class DialogAcessoSimulado {
  email: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAcessoSimulado>,
    public security: SecurityService
  ) { }

  setUserSimulado() {
    const emailToSearch = this.email?.trim();

    if (emailToSearch.length > 0) {
      this.security.setUserSimulado(emailToSearch);
    }
  }
}

@Component({
  selector: 'dialog-encerrar-ativacao',
  templateUrl: 'dialog-encerrar-ativacao.html',
})
export class DialogEncerrarAtivacao {
  botoes = true;
  motivoFinalizarForm: FormGroup;
  error;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Ativacao,
    private ativacaoService: AtivacoesService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogEncerrarAtivacao>,
    public securityService: SecurityService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.motivoFinalizarForm = this.fb.group({
      motivo: ['', Validators.required],
    });
  }

  enviarFinalFila() {
    this.securityService.enviarFinalFila(this.data).then((res) => {
      this.dialogRef.close(true);
    });
  }

  finalizarContato() {
    if (this.motivoFinalizarForm.valid) {
      this.securityService
        .finishWithNoContact(this.data, this.motivoFinalizarForm.value.motivo)
        .then((res) => {
          this.dialogRef.close(true);
        });
    } else {
      this.error = 'Favor preencher o motivo.';
    }
  }
}

interface ClipboardItem2 {
  readonly types: string[];
  readonly presentationStyle: 'unspecified' | 'inline' | 'attachment';
  getType(): Promise<Blob>;
}

interface ClipboardItemData {
  [mimeType: string]: Blob | string | Promise<Blob | string>;
}

declare var ClipboardItem: {
  prototype: ClipboardItem2;
  new(itemData: ClipboardItemData): ClipboardItem2;
};

interface Clipboard2 {
  read(): Promise<DataTransfer>;
  write(data: ClipboardItem2[]): Promise<void>;
}

@Component({
  selector: 'dialog-whatsapp',
  templateUrl: 'dialog-whatsapp.html',
})
export class DialogWhatsApp {
  error = false;
  dialogInicial = true;
  showConfirmacao = false;
  dialogAtivacaoMalSucedida = false;

  whatsAppLink;
  text;
  userAgentIsIOS: boolean = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      ativacao: Ativacao;
      midia: Midia;
      modoCampanha: boolean;
      ativacaoEspontanea: boolean;
    },
    private ativacaoService: AtivacoesService,
    private dialog: MatDialog,
    public dialgoRef: MatDialogRef<DialogWhatsApp>,
    public securityService: SecurityService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private utils: UtilsService,
    private platform: Platform,
    private http: HttpClient
  ) {
    this.text = encodeURIComponent(this.data.midia.texto);
    this.whatsAppLink = `whatsapp://send?text=${this.text}&phone=+55${this.data.midia.celular}`;
    this.whatsAppLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.whatsAppLink
    );
    console.log(navigator.userAgent);
    console.log(this.data);
  }

  getImagem(url: string) {
    try {
      if (this.isFormat(url, ['pdf'])) {
        return 'assets/icons/pdf.png';
      } else {
        return url;
      }
    } catch (e) { }
  }

  isFormat(fileUrl: string, formats: string[]) {
    const parts = fileUrl.split('.');
    return formats.includes(parts[parts.length - 1].split('?')[0]);
  }

  async copyImage(imgUrl: string) {
    this.spinner.show();

    copyImg(imgUrl)
      .then((res) => {
        this.spinner.hide();
        this.utils.popSnackBar('Imagem copiada com sucesso!');
      })
      .catch((error) => {
        this.spinner.hide();
        console.error(error);
        this.utils.popSnackBar(
          'Ocorreu um erro ao tentar copiar a imagem. Tente fazer o download.', 5, true
        );
      });
  }

  openChat() {
    if (this.userAgentIsIOS) {
      this.firstOptionWhatsapp();
    } else {
      this.openChatSemConfirmacao();
    }
  }

  firstOptionWhatsapp() {
    const text = encodeURIComponent(this.data.midia.texto);
    const link = `whatsapp://send?text=${text}&phone=55${this.data.midia.celular}`;
    this.spinner.show();
    window.open(link, '_blank');
    this.spinner.hide();

    const evento = {
      id_ativacao: this.data.ativacao.id_ativacao,
      id_cliente: this.data.ativacao.id_cliente,
      id_vendedor: this.data.ativacao.id_vendedor,
      midia: this.data.midia.tipo_midia,
    };
    this.securityService.registrarEvento('clicou-whatsapp', evento).subscribe(
      (res: any) => { },
      (err) => {
        this.error = true;
      }
    );
  }

  secondLinkHandler() {
    if (this.userAgentIsIOS) {
      this.openChatSemConfirmacao();
    } else {
      this.firstOptionWhatsapp();
    }
  }

  openChatSemConfirmacao() {
    const text = encodeURIComponent(this.data.midia.texto);
    const link = `https://wa.me/55${this.data.midia.celular}?text=${text}`;
    window.open(link, '_blank');
    this.securityService
      .registrarEvento('abriu-zap-web', {
        id_ativacao: this.data.ativacao.id_ativacao,
        id_cliente: this.data.ativacao.id_cliente,
        id_vendedor: this.data.ativacao.id_vendedor,
        midia: this.data.midia.tipo_midia,
      })
      .subscribe((res) => { });
  }

  close() {
    this.dialog.closeAll();
  }

  mainActivation() {
    this.dialgoRef.close();
    this.securityService.mainActivation(
      this.data.ativacao,
      this.data.midia.tipo_midia
    );
  }

  getCurrentDateInSaoPaulo(): string {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'America/Sao_Paulo',
    };

    // Use Intl.DateTimeFormat and manually join parts for the correct format
    const formatter = new Intl.DateTimeFormat('en-GB', options);
    const parts = formatter.formatToParts(now);

    const day = parts.find((p) => p.type === 'day')?.value;
    const month = parts.find((p) => p.type === 'month')?.value;
    const year = parts.find((p) => p.type === 'year')?.value;
    const hour = parts.find((p) => p.type === 'hour')?.value;
    const minute = parts.find((p) => p.type === 'minute')?.value;
    const second = parts.find((p) => p.type === 'second')?.value;

    // Return the formatted date string without commas
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
  }

  confirmar(status: 'ativou' | 'nao-ativou' | 'ativou-next') {
    this.spinner.show();
    if (status == 'ativou' || status == 'ativou-next') {
      this.securityService
        .registrarEvento('executou-ativacao', {
          id_ativacao: this.data.ativacao.id_ativacao,
          id_cliente: this.data.ativacao.id_cliente,
          id_vendedor: this.data.ativacao.id_vendedor,
          midia: this.data.midia.tipo_midia,
        })
        .subscribe(
          (res: any) => {
            if (res.messageId) {
              this.spinner.hide();
              this.dialgoRef.close(true);
              if (status == 'ativou-next') {
                if (this.data.ativacaoEspontanea) {
                  this.ativacaoService
                    .sendFinalizouAtivacaoEvent(this.data.ativacao)
                    .subscribe((res) => res);
                } else {
                  this.ativacaoService.finalizarContato(
                    this.ativacaoService.ativacaoAtual,
                    this.securityService.currentUserValue
                  );
                }
              } else if (status == 'ativou') {
                this.ativacaoService.executarAcaoContato(
                  this.data.ativacao,
                  res.messageId
                );
              }
            } else {
              this.error = true;
              this.spinner.hide();
            }
          },
          (err) => {
            this.error = true;
            this.spinner.hide();
          }
        );
    } else {
      this.securityService
        .registrarEvento('ativacao-mal-sucedida', {
          id_ativacao: this.data.ativacao.id_ativacao,
          id_cliente: this.data.ativacao.id_cliente,
          id_vendedor: this.data.ativacao.id_vendedor,
          midia: this.data.midia.tipo_midia,
        })
        .subscribe((res) => {
          this.spinner.hide();
          this.dialog.closeAll();
        });
    }
  }

  ativacaoMalSucedida(motivo: string) {
    this.spinner.show();
    this.securityService
      .registrarEvento('motivo-nao-envio-zap', {
        id_ativacao: this.data.ativacao.id_ativacao,
        id_cliente: this.data.ativacao.id_cliente,
        id_vendedor: this.data.ativacao.id_vendedor,
        motivo: motivo,
      })
      .subscribe((res) => {
        this.spinner.hide();
        this.dialog.closeAll();
      });
  }

  naoEnviouZap() {
    this.securityService
      .registrarEvento('nao-enviou-zap', {
        id_ativacao: this.data.ativacao.id_ativacao,
        id_cliente: this.data.ativacao.id_cliente,
        id_vendedor: this.data.ativacao.id_vendedor,
      })
      .subscribe((res) => { });
  }
}

@Component({
  selector: 'dialog-aviso-atv-14-dias',
  templateUrl: 'dialog-aviso-atv-14-dias.html',
})
export class DialogAvisoAtv14Dias {
  constructor(
    private dialog: MatDialog,
    public dialgoRef: MatDialogRef<DialogAvisoAtv14Dias>,
    public securityService: SecurityService
  ) { }

  confirm() {
    this.dialgoRef.close(true);
  }
}

@Component({
  selector: 'dialog-notas',
  templateUrl: 'dialog-notas.html',
  styleUrls: ['./styles/dialog-notas.scss'],
})
export class DialogNotas implements OnInit, OnDestroy {
  notas!: Notas;
  newNotaText!: string;
  notasSubscription!: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      clienteCpf: string;
      clienteSiglaMarca: string;
      notaType: 'ANOTACAO' | 'LEMBRETE';
      cliente: Cliente;
    },
    private dialog: MatDialog,
    private fireReqs: FirebaseRequestsService
  ) { }

  ngOnInit() {
    this.notasSubscription = this.fireReqs
      .getNotasCliente(this.data.clienteCpf, this.data.clienteSiglaMarca)
      .subscribe((notas) => {
        this.notas = notas;
      });
  }

  createNewNota() {
    if (this.newNotaText) {
      this.fireReqs
        .setNota(
          this.data.clienteCpf,
          this.data.clienteSiglaMarca,
          this.newNotaText,
          this.data.notaType,
          this.data.cliente
        )
        .subscribe((res) => {
          console.log('Note added!');
          this.newNotaText = '';
        });
    }
  }

  get hasAnotacoes(): boolean {
    return this.notas?.notas?.some((nota) => nota.concluido);
  }

  get hasLembretes(): boolean {
    return this.notas?.notas?.some((nota) => !nota.concluido);
  }

  ngOnDestroy(): void {
    this.notasSubscription.unsubscribe();
  }
}

@Component({
  selector: 'dialog-ligacao',
  templateUrl: 'dialog-ligacao.html',
})
export class DialogLigacao {
  clicouLigacao = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { ativacao: Ativacao; midia: Midia },
    private ativacaoService: AtivacoesService,
    private dialog: MatDialog,
    public securityService: SecurityService,
    private spinner: NgxSpinnerService
  ) { }

  openLigacao() {
    this.clicouLigacao = true;
  }

  conseguiu() {
    this.securityService.yes(this.data.ativacao, this.data.midia.tipo_midia);
  }

  naoConsegui() {
    this.spinner.show();
    this.securityService
      .registrarEvento('ativacao-mal-sucedida', {
        id_ativacao: this.data.ativacao.id_ativacao,
        id_cliente: this.data.ativacao.id_cliente,
        id_vendedor: this.data.ativacao.id_vendedor,
        midia: this.data.midia.tipo_midia,
      })
      .subscribe((res) => {
        this.spinner.hide();
        this.dialog.closeAll();
      });
  }

  close() {
    this.dialog.closeAll();
  }
}

@Component({
  selector: 'dialog-descadastrar-cliente',
  templateUrl: 'dialog-descadastrar-cliente.html',
})
export class DialogDescadastrarCliente {
  clicouLigacao = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ativacaoService: AtivacoesService,
    private dialog: MatDialog,
    public securityService: SecurityService,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<DialogDescadastrarCliente>
  ) { }

  descadastrarCliente() {
    console.log(this.data);

    if (this.data.id_ativacao) {
      this.securityService.descadastrar(this.data);
      this.dialogRef.close(true);
    } else {
      this.securityService.descadastrar(
        this.data,
        'event-only',
        'descadastro-busca'
      );
      this.dialogRef.close(true);
    }
  }

  close() {
    this.dialog.closeAll();
  }
}

@Component({
  selector: 'dialog-sem-conexao',
  templateUrl: 'dialog-sem-conexao.html',
  styleUrls: ['./styles/dialog-sem-conexao.scss'],
})

export class DialogSemConexao {
  verificando = false;
  semConexaoAposVerificar = false;

  constructor(
    public dialogRef: MatDialogRef<DialogSemConexao>,
    private networkService: NetworkStatusService
  ) {
    // Impede fechar clicando fora ou pressionando ESC
    this.dialogRef.disableClose = true;
  }

  async verificarConexao(): Promise<void> {
    this.verificando = true;
    this.semConexaoAposVerificar = false;

    const conectado = await this.networkService.checkConnection();

    this.verificando = false;

    if (conectado) {
      this.dialogRef.close(true);
    } else {
      this.semConexaoAposVerificar = true;
    }
  }
}

